import { observer } from 'mobx-react-lite'
import { useTranslationTyped } from 'i18n/i18n'
import classNames from 'classnames'

export const ChatRoomStartedSyntheticMessage = observer(
  function ChatRoomStartedSyntheticMessage({
    roomStartedAt,
    className,
    includeDate = true,
  }: {
    roomStartedAt: Date
    className?: string
    includeDate?: boolean
  }) {
    const { tt } = useTranslationTyped()

    // Format timestamp
    const formattedTime = roomStartedAt.toLocaleString(undefined, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
    })

    return (
      <div
        className={classNames(
          'flex flex-col items-center rounded-xl px-4 py-3',
          className
        )}
      >
        <div className="text-center text-body-medium font-medium text-on-surface">
          {tt.meeting.session_started()}
        </div>
        {includeDate && (
          <div className="text-center text-body-small font-light text-on-surface-var">
            {formattedTime}
          </div>
        )}
      </div>
    )
  }
)
